define('app-Slider/main',['./settings', "util", 'bxslider', 'hoverIntent'], function (settings, util) {
    return {
        run: function () {
            if ($(settings.container).length === 0) {
                window.log('No slider container found.  Slider will not be available.');
                return;
            }

            window.log('Loading slider.');

            $(document).ready(function () {
                if ($('.newHeroContent')[0]) {
                    var test = $('.heroSlide1').height();

                }


                // capture the next arrow click on the carouosel and write to the adl variables
                $(".bx-next").click(function (event) {
                    var index = $('.bx-pager-link.active').text().trim() - 1;
                    var imgurl = $('.bxslider li').eq(index).css("background-image");

                    AdlAddUpdateItem("activeSlide", imgurl);
                    util.satelliteTrack('carousel interaction');
                });

                // capture the prev arrow click on the carouosel and write to the adl variables
                $(".bx-prev").click(function (event) {
                    var index = $('.bx-pager-link.active').text().trim() - 1;
                    var imgurl = $('.bxslider li').eq(index).css("background-image");

                    AdlAddUpdateItem("activeSlide", imgurl);
                    util.satelliteTrack('carousel interaction');
                });

                // capture the 'dot' click on the carouosel and write to the adl variables
                $(".bx-pager-link").click(function (event) {
                    //get position of dot to pick up image url
                    var index = $(this).text().trim() - 1;
                    var imgurl = $('.bxslider li').eq(index).css("background-image");
                    var baseUrl = document.location.origin + "/";
                    imgurl = imgurl.replace('url(', '').replace(baseUrl, '').replace(')', '');

                    AdlAddUpdateItem("activeSlide", imgurl);
                    util.satelliteTrack('carousel interaction');
                });
            });

            $(settings.container).bxSlider({
                mode: 'fade',
                controls: ($(".bxslider>li").length > 1) ? true : false,
                video: false,
                pager: ($(".bxslider>li").length > 1) ? true : false,
                pagerType: 'short',
                nextText: '',
                prevText: '',
                infiniteLoop: false,
                hideControlOnEnd: true,
                useCSS: false,
                touchEnabled: false,
                autoHover: true,
                autoControls: true
            });

            $('.bxslider').find(settings.descriptions).hide();
            $(".bx-pager").insertBefore(".bx-controls .bx-next");

            $('.bxslider').find(settings.titles).click(function (e) {
                e.preventDefault();
                if ($('.bxslider').find(settings.descriptions).is(':visible')) $('.bxslider').find(settings.descriptions).slideUp(120);
                else $('.bxslider').find(settings.descriptions).slideDown(50);
            });

            $('.bxslider').find(settings.titles).hoverIntent({
                over: function () {
                    $('.bxslider').find(settings.descriptions).slideDown(50);
                },
                out: function () {
                    $('.bxslider').find(settings.descriptions).slideUp(120);
                },
                timout: 150
            });

            window.loadedModules('Slider');

            $('#countdown').each(function () {
                $(this).prop('Counter', 0).animate({
                    Counter: $(this).data('daystogo')
                }, {
                    duration: 4000,
                    easing: 'swing',
                    step: function (now) {
                        $(this).text(Math.ceil(now));
                    }
                });
            });

            var iframeWidth = $("#player").width();
            var windowWidth = $(window).width();
            var move = (iframeWidth - windowWidth) / 2;

            $("#player").css({ 'margin-left': '-' + move + 'px', 'display': 'block' });

            $(window).resize(function () {
                var iframeWidth = $("#player").width();
                var windowWidth = $(window).width();
                var move = (iframeWidth - windowWidth) / 2;
                $("#player").css({ 'margin-left': '-' + move + 'px', 'display': 'block' });
            });



            $(".scrollToContent").click(function () {
                $('html, body').animate({
                    scrollTop: $("#content").offset().top
                }, 1000)
            });


            function moveHeroContent() {

                if ($(window).width() <= 767) {
                    if ($('.jumbotronMobile ').is(':visible' && ':empty')) {
                        if ($('.newHeroContent')[0]) {
                            $('.heroSlide1 .innerText').appendTo(".jumbotronMobile");
                            $('.jumbotronMobile').addClass('jumbotronMobileActive');
                        }
                        else if ($('.productInfoContent')[0]) {
                            $('.jumbotron__container .productInfoContent h1').appendTo(".jumbotronMobile");
                            $('.jumbotron__container .productInfoContent .innerText').hide();
                        }
                    }
                }
                else {
                    if ($('.heroSlide1').is(':visible' && ':empty')) {
                        $('.jumbotronMobile .innerText').appendTo(".heroSlide1");
                        $('.jumbotronMobile').addClass('jumbotronMobileActive');
                    }
                    else if ($('.productInfoContent').is(':visible')) {
                        $('.jumbotronMobile h1').appendTo("#frostedContentsInner");
                        $('.jumbotron__container .productInfoContent .innerText').show();

                    }
                }

            }
            moveHeroContent();


            //Set video height
            function resizeVimeo() {
                if ($('.vimeoSlide').is(':visible')) {
                    var navHeight = $("#slider").offset().top
                    var windowHeight = $(window).height();
                    var maxHeight = windowHeight - navHeight;
                    //$('#content').css("padding-top", "0px");
                    if ($(window).width() >= 767) {
                        $('.vimeoVideo, #slider, .bxslider').css('max-height', maxHeight + 'px');
                    }
                    else {
                        $('.vimeoVideo, #slider, .bxslider').css('max-height', maxHeight - 100 + 'px');
                    }
                    $('.vimeoContent').fadeIn();
                    if ($(window).width() >= 992) {
                        $('#slider').css('min-height', '300px');

                    }
                    else {
                        $('#slider').css('min-height', '200px');
                    }
                    if ($("#newMiniSearch").length) {
                        $('.bx-wrapper').css('overflow', 'hidden');
                        $('#slider').css('max-height', 'none');
                    }
                }
            }
            resizeVimeo();


            $(window).resize(function () {
                resizeVimeo();
                moveHeroContent();
                showCruiseSearch();
            });
            if ($('.jumbotronMobile ').is(':visible' && ':empty')) {
                $('.jumbotronMobile').hide();
            }
            function showCruiseSearch() {
                if ($('.maxiCruise').is(':visible')) {
                    var searchControlHeight = $('#searchControl').outerHeight();

                    if ($(window).width() >= 992) {
                        $('#searchControl').css({ 'margin-top': "-" + searchControlHeight / 2 + "px", 'opacity': '100' });
                        $('#newMiniSearch').css({ 'margin-top': 0 + 'px' });

                    }

                    else {
                        $('#searchControl').css({ 'margin-top': 0 + 'px', 'opacity': '0' });
                        if ($(window).width() >= 768) {
                            var sliderHeight = $('.bx-wrapper').height();
                            $('.heroContentNoNav ').css({ 'height': sliderHeight + 'px' });
                        }
                        else {
                            $('.heroContentNoNav ').css({ 'height': '100%' });
                        }
                    };


                }
            };
            showCruiseSearch();

            

        }
    }
});
